import * as React from 'react';
import BarChart from '../BarChart';
import { buildClassString } from '../StringUtils';
import { FormattedCurrency } from '../EmployeeDetailsCards/common/FormattedCurrency';
import './style/index.scss';
export class BenefitsChart extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { className, totalCashCompensation, companyContributions, height, currencyFormatter } = this.props;
        const bars = [];
        let tccTotal = 0;
        let contributionsTotal = 0;
        if (totalCashCompensation && totalCashCompensation.length > 0) {
            tccTotal = totalCashCompensation.reduce((prevValue, currentValue) => {
                return prevValue + Number(currentValue.value);
            }, 0);
            bars.push({
                value: tccTotal,
                className: 'benefits-chart__total-cash'
            });
        }
        if (companyContributions && companyContributions.length > 0) {
            contributionsTotal = companyContributions.reduce((prevValue, currentValue) => {
                return prevValue + Number(currentValue.value);
            }, 0);
            bars.push({
                value: contributionsTotal,
                className: 'benefits-chart__company-contributions'
            });
        }
        let compensationRatio = 0;
        if (tccTotal && contributionsTotal) {
            compensationRatio = contributionsTotal / (contributionsTotal + tccTotal);
        }
        const benefitsCardClassName = buildClassString({
            'benefits-chart': true,
            [className]: !!className
        });
        const cardHeight = height ? height : 500;
        const totalCompMarginTop = cardHeight * compensationRatio;
        const benefitBarStyle = {
            height: cardHeight + 'px'
        };
        const totalCompStyle = {
            marginTop: totalCompMarginTop + 'px'
        };
        return (React.createElement("div", { className: benefitsCardClassName },
            React.createElement("div", { className: "benefits-chart__tcc-panel", style: totalCompStyle },
                React.createElement("div", { className: "tcc-panel__header" },
                    React.createElement("div", { className: "tcc-panel__title" },
                        React.createElement("div", { className: "tcc-panel__title-text" },
                            "Total Cash",
                            React.createElement("br", null),
                            "Compensation")),
                    React.createElement("div", { className: "tcc-panel__value" },
                        React.createElement("div", { className: "tcc-panel__line" }),
                        React.createElement(FormattedCurrency, { val: tccTotal, sensitiveValue: false, formatFunc: currencyFormatter }))),
                totalCashCompensation && this._renderBenefitItems(totalCashCompensation, 'totalCompensation'),
                this._renderUncalculatedBenefits()),
            React.createElement("div", { className: "benefits-chart__bar-chart", style: benefitBarStyle },
                React.createElement(BarChart, { bars: bars, verticalBarChart: true })),
            React.createElement("div", { className: "benefits-chart__company-panel" }, companyContributions && companyContributions.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "company-panel__header" },
                    React.createElement("div", { className: "company-panel__line" }),
                    React.createElement("div", { className: "company-panel__title" },
                        React.createElement("div", { className: "tcc-panel__title-text" },
                            "Company",
                            React.createElement("br", null),
                            "Contributions")),
                    React.createElement("div", { className: "company-panel__value" },
                        React.createElement(FormattedCurrency, { val: contributionsTotal, sensitiveValue: false, formatFunc: currencyFormatter }))),
                this._renderBenefitItems(companyContributions, 'companyContribution'))))));
    }
    _renderBenefitItems(benefitItems, benefitName) {
        const benefits = [];
        benefitItems.forEach((benefit) => {
            benefits.push(this._renderBenefit(benefit));
        });
        return (React.createElement("div", { className: "benefits-chart__benefit-items", key: benefitName }, benefits));
    }
    _renderBenefit(benefit) {
        return (React.createElement("div", { className: "benefits-chart__benefit", key: benefit.label },
            React.createElement("span", { className: "benefits-chart__benefit-title", key: `${benefit.label}Title` }, benefit.label),
            React.createElement("span", { className: "benefits-chart__benefit-value", key: `${benefit.label}Value` },
                React.createElement(FormattedCurrency, { val: benefit.value, sensitiveValue: false }))));
    }
    _renderUncalculatedBenefits() {
        const { uncalculatedBenefits } = this.props;
        if (!uncalculatedBenefits || uncalculatedBenefits.length <= 0) {
            return null;
        }
        return (React.createElement("div", { className: "benefits-chart__uncalculated-panel" },
            React.createElement("div", { className: "uncalculated-panel__header" }, "Not included in your total"),
            React.createElement("div", { className: "uncalculated-panel__container" },
                React.createElement("span", { className: "uncalculated-panel__title" }, "Paid Leave"),
                React.createElement("div", { className: "uncalculated-panel__paid-leave" }, this._renderBenefitItems(uncalculatedBenefits, 'paidLeave')))));
    }
}
export default BenefitsChart;
